import styled from 'styled-components'

export const GridContainer = styled.div<{ backgroundColor: string }>`
    padding: 0;
    display: grid;
    font-family: 'Open Sans', Helvetica, sans-serif;
    grid-template-columns: 1fr; /* Side nav is hidden on mobile */
    grid-template-rows: 1fr 50px;
    grid-template-areas:
        'main'
        'footer';
    height: 100vh;
    background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : 'transparent'},
        @media only screen and (min-width: 46.875em) {
        grid-template-columns: 1fr; /* Show the side nav for non-mobile screens */
        grid-template-areas:
            'main'
            'footer';
    }
`

export const GridContainerOverlay = styled.div`
    position: absolute;
    z-index: 999;
    height: 100%;
    width: 100%;
    padding: 0;
    opacity: 0.4;
    pointer-events: none;
`
